import { useTranslation } from 'react-i18next'

import { useAddressStore } from '@features/shipping-methods'

import { ProductCarousel } from '@widgets/product-carousel'



import { IMAGE_SIZES, URL_CATEGORY_NEW_PRODUCTS } from '@shared/contants'
import { Product, useProductsPreviewCardQuery } from '@shared/generated'

export default function ProductCarouselNew () {
  const { t: tp } = useTranslation('product')
  const { shopId } = useAddressStore()
  const { data, loading } = useProductsPreviewCardQuery({
    variables: {
      shopId: shopId,
      style: IMAGE_SIZES.TABLET,
      sort: {
        fieldName: 'new',
      },
    },
  })

  return (
    <>
      {data && data.products?.edges && data.products?.edges?.length > 0 && (
        <ProductCarousel
          link={URL_CATEGORY_NEW_PRODUCTS}
          title={tp('new')}
          products={data.products?.edges as Product[]}
          loading={loading}
          listName="New Products"
        />
      )}
    </>
  )
}